import { getMondayOfWeek, formatCalendarDate } from '@opentri/shared';
import apiClient from './apiClient';

export interface UserProps {
  user_id: string;
  name?: string;
  created_at: string;
  email: string;
  first_name: string;
  avatar_url?: string;
  role: 'user' | 'admin';
  latest_plan: string;
  current_plan: string;
  plan_start_date: string;
  competition_date: string | null;
  stripe_customer_id?: string;
  rpe_swimming?: boolean;
  rpe_cycling?: boolean;
  rpe_running?: boolean;
  isBeta?: boolean;
  gender?: string;
  date_of_birth?: string;
  trial_end_date?: string | null;
  payment_failed?: boolean;
}

export const searchUsers = async (term: string): Promise<UserProps[]> => {
  const response = await apiClient.post('admin/users/search', { term });
  return response.data as UserProps[];
};

export const getRecentUsers = async (limit = 15): Promise<UserProps[]> => {
  const response = await apiClient.get('admin/users/recent', { params: { limit } });
  return response.data as UserProps[];
};

export const assignPlanToUser = async (
  user_id: string,
  plan_id: string,
  competition_date: Date,
  latest_plan: string | null,
  weekCount: number
): Promise<UserProps[]> => {
  if (!weekCount || weekCount < 1) {
    throw new Error(`Invalid plan: must have at least 1 week (got ${weekCount})`);
  }

  const tempDate = new Date(competition_date);
  tempDate.setDate(tempDate.getDate() - (weekCount - 1) * 7);
  const plan_start_date = getMondayOfWeek(formatCalendarDate(tempDate));

  const response = await apiClient.post('admin/users/assign-plan', {
    user_id,
    plan_id,
    competition_date,
    plan_start_date,
    latest_plan,
  });
  return response.data as UserProps[];
};

export const deleteUser = async (userId: string) => {
  const response = await apiClient.delete(`admin/users/${userId}`);
  return response.data;
};

export interface PasswordResetLink {
  url: string;
  expiresAt: string;
  authEmail: string;
}

export const generatePasswordResetLink = async (userId: string): Promise<PasswordResetLink> => {
  const response = await apiClient.post(`admin/users/${userId}/reset-link`);
  return response.data as PasswordResetLink;
};

export const toggleSportRpe = async (
  sport: 'swimming' | 'cycling' | 'running',
  state: boolean,
  userId: string
) => {
  const response = await apiClient.put('admin/users', {
    userId,
    updates: { [`rpe_${sport}`]: state },
  });
  return response.data;
};
